var _excluded = ["className", "description", "logoSrc", "linkProps", "name", "nameTag", "tagLabel", "tagLogo"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { BOX_SIZES } from "#library/components/Image/Image";
import { Card } from "#library/components/Card";
import { Logo } from "#library/components/Image/Logo";
import defaultLogo from "#library/assets/images/default_company_logo.png";
import { Text, TEXT_WEIGHTS } from "#library/components/Text/Text";
import { TagUniversity } from "#library/components/Tag";
import styles from "./CompanyCard.module.css";
export var CompanyCard = function CompanyCard(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    description = _ref.description,
    logoSrc = _ref.logoSrc,
    linkProps = _ref.linkProps,
    name = _ref.name,
    nameTag = _ref.nameTag,
    tagLabel = _ref.tagLabel,
    tagLogo = _ref.tagLogo,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Card, _extends({
      className: className
    }, restProps), /*#__PURE__*/React.createElement(Card.Body, {
      className: styles["jds-CompanyCard__wrappper"]
    }, /*#__PURE__*/React.createElement(Logo, {
      src: logoSrc,
      onLoadErrorPath: defaultLogo,
      className: styles["jds-CompanyCard__logo"],
      boxSize: BOX_SIZES.BIG,
      alt: ""
    }), /*#__PURE__*/React.createElement("div", {
      className: styles["jds-CompanyCard__textWrapper"]
    }, tagLabel && tagLabel.length > 0 && /*#__PURE__*/React.createElement(TagUniversity, {
      label: tagLabel,
      universityLogo: tagLogo,
      className: styles["jds-CompanyCard__tag"]
    }), /*#__PURE__*/React.createElement(Card.Title, {
      resetSpacing: true,
      as: nameTag,
      linkProps: linkProps
    }, /*#__PURE__*/React.createElement("span", {
      className: styles["jds-CompanyCard__title"]
    }, name)), /*#__PURE__*/React.createElement(Text, {
      resetSpacing: true,
      weight: TEXT_WEIGHTS.BOLD,
      className: styles["jds-CompanyCard__description"]
    }, description))))
  );
};